import { provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, isDevMode, provideZoneChangeDetection } from '@angular/core';
import { provideClientHydration } from '@angular/platform-browser';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideEffects } from '@ngrx/effects';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideAngularSvgIcon } from 'angular-svg-icon';
import { routes } from './app.routes';
import { deviceDetailsInterceptor } from './assessment/common/interceptors/device-details.interceptor';
import { provideApplicationInsights } from './assessment/providers/logging.provider';
import { AssessmentEffects } from './assessment/store/effects/assessment.effects';
import { PageEffects } from './assessment/store/effects/page.effects';
import {
  getInitialAssessmentReducer,
  setAssessmentReducer,
  updateAssessmentReducer,
} from './assessment/store/reducers/assessment.reducers';
import { campaignSettingsReducer, contentReducer } from './assessment/store/reducers/campaign.reducers';
import { pageContentReducer } from './assessment/store/reducers/page-content.reducers';
import { pageLoadingReducer } from './assessment/store/reducers/page-loading.reducers';
import { pageReducer } from './assessment/store/reducers/page.reducers';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
      }),
    ),
    provideClientHydration(),
    provideStore({
      initialAssessment: getInitialAssessmentReducer,
      updateAssessment: updateAssessmentReducer,
      page: pageReducer,
      pageContent: pageContentReducer,
      loadingData: pageLoadingReducer,
      setAssessment: setAssessmentReducer,
      setCampaignContent: contentReducer,
      getCampaignContent: contentReducer,
      setCampaignSettings: campaignSettingsReducer,
      getCampaignSettings: campaignSettingsReducer,
    }),
    provideEffects([AssessmentEffects, PageEffects]),
    provideStoreDevtools({ maxAge: 25, logOnly: isDevMode() }),
    provideHttpClient(withInterceptorsFromDi(), withFetch(), withInterceptors([deviceDetailsInterceptor])),
    provideAngularSvgIcon(),
    provideApplicationInsights(),
  ],
};
